import { CustomerGroupModelType } from '@teinor/erp/types/company/customer/customerGroup'

export const parseCustomerGroups = (customerGroups: CustomerGroupModelType[]) => {
    let result: number[] = []
    for (const key in customerGroups) {
        const customerGroup = customerGroups[key]
        result.push(customerGroup.id)
    }
    return result
}